import Vue from 'vue';
import VueI18n from 'vue-i18n';
import zhCN from './zh-CN';
import enUS from './en-US';

// 导入Element UI官方语言包
import ElementLocale from 'element-ui/lib/locale';
import elementZhCN from 'element-ui/lib/locale/lang/zh-CN';
import elementEnUS from 'element-ui/lib/locale/lang/en';

Vue.use(VueI18n);

// 合并自定义翻译与Element UI翻译
const messages = {
    'zh-CN': {
        ...zhCN,
        ...elementZhCN  // 新增Element UI中文翻译
    },
    'en-US': {
        ...enUS,
        ...elementEnUS  // 新增Element UI英文翻译
    }
};

// const i18n = new VueI18n({
//     locale: localStorage.getItem('language') || 'zh-CN',
//     messages: {
//         'zh-CN': zhCN,
//         'en-US': enUS
//     }
// });
const i18n = new VueI18n({
    locale: localStorage.getItem('language') || 'zh-CN',
    fallbackLocale: 'zh-CN',
    messages: messages
});

// 关键：将i18n与Element UI关联
ElementLocale.i18n((key, value) => i18n.t(key, value));

export default i18n;